import axios from 'axios';

// Remembers an entry invite token between opening the invite link and finishing register/login.
const STORAGE_KEY = 'pending_entry_invite';

export const rememberInvite = (token) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, token);
  } catch (e) {}
};

export const getRememberedInvite = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    return null;
  }
};

export const forgetInvite = () => {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (e) {}
};

export const fetchInvite = (token) =>
  axios.get(process.env.REACT_APP_API_ENDPOINT + `entry-invite/${encodeURIComponent(token)}`);

export const acceptInvite = (token, userId, userToken) =>
  axios.post(process.env.REACT_APP_API_ENDPOINT + `entry-invite/${encodeURIComponent(token)}/accept`, {}, {
    params: { user_id: userId, token: userToken },
  });

// Failures where the invite can still be accepted later, e.g. after logging in with the right account
export const isRetryableInviteError = (code) => code === 'login_required' || code === 'email_mismatch';
